


































































import { Vue, Component, Emit, Watch } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue';
import { TableStripe } from '@/mixins/tableStripe';
import publicPage from '@/views/doublePrevention/riskControlList/publicPage.vue';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import publicProp from '@/views/videoManagement/videoBind/publicProp.vue';
import { regionServe, videoManagement } from '@/api/installServer';
import { arrayToTree } from '@/util/array';

@Component({
  components: { PagingUnit, publicPage, CollapseTransition, publicProp },
  mixins: [TableStripe],
})
export default class HazardChecklist extends Vue {
  private rowId: any = {};
  private orgList: any = [];
  private searchForm: any = {
    videoName: '', // 视频名称
    areaId: '', // 区域id
    isShowMap: null, // 是否地图显示
  };
  private tableData: any = [];
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  private total = 0;
  private spaceAreaList: any = []; // 区域的下拉
  private keyValue: any = 0;
  private isMapShowList: any = [
    {
      label: '显示',
      value: true,
    },
    {
      label: '隐藏',
      value: false,
    },
  ]; // 管控层级

  private onSearch() {
    this.getData();
  }

  private onreset() {
    this.searchForm = {
      videoName: '', // 模糊搜索
      areaId: '', // 区域id
      isShowMap: null, // 是否地图显示
    };
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getData();
  }

  private getData() {
    videoManagement
      .getVideoPageData({
        pageNo: this.queryDataForm.pageNo,
        pageSize: this.queryDataForm.pageSize,
        videoName: this.searchForm.videoName ? this.searchForm.videoName : null, // 视频名称
        areaId: this.searchForm.areaId ? this.searchForm.areaId[this.searchForm.areaId.length - 1] : null, // 区域
        isShowMap: this.searchForm.isShowMap === true ? true : this.searchForm.isShowMap === false ? false : null,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.warning(res.msg);
        }
      });
  }

  private getListData() {
    this.getData();
  }

  private showPublicProp(type: any, data: any) {
    this.rowId.data = data;
    this.rowId.type = type;
    if (type !== 'delete') {
      // 详情、编辑、添加的弹窗
      (this.$refs as any).publicProp.showDialog();
    } else {
      this.deleteVideo();
    }
  }

  // 删除
  private deleteVideo() {
    this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        videoManagement.deleteVideo(this.rowId.data.id).then((res: any) => {
          if (res.code === '200') {
            this.$message.success('成功删除该条数据！');
            this.queryDataForm = {
              pageNo: 1,
              pageSize: 10,
            };
            this.searchForm = {};
            this.getData();
          } else {
            this.$message.warning(res.msg);
          }
        });
      })
      .catch(() => {
        this.$message.info('已取消删除');
      });
  }

  orgIdToName(id: any) {
    const a: any = this.orgList.find((s: any) => {
      return s.id === id;
    });
    let d: any = '';
    if (a) {
      d = a.name;
    }
    return d;
  }

  // 区域列表
  getSpaceAreaData() {
    regionServe.getRegionAllData({}).then((res: any) => {
      if (res.code === '200') {
        this.spaceAreaList = arrayToTree(res.data);
      } else {
        this.$message.warning('获取区域的列表失败！');
      }
    });
  }

  created() {
    this.getData();
    this.getSpaceAreaData();
  }

  mounted() {}

  @Watch('spaceAreaList')
  private checkedScroll() {
    this.keyValue++;
  }

  getPageData() {
    this.getData();
  }
}
